"use strict";

var _slicedToArray = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _nullishCoalesce(lhs, rhsFn) {
  if (lhs != null) {
    return lhs;
  } else {
    return rhsFn();
  }
}

function _optionalChain(ops) {
  var lastAccessLHS = undefined;
  var value = ops[0];
  var i = 1;

  while (i < ops.length) {
    var op = ops[i];
    var fn = ops[i + 1];
    i += 2;

    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }

    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn(function () {
        var _value;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (_value = value).call.apply(_value, [lastAccessLHS].concat(args));
      });
      lastAccessLHS = undefined;
    }
  }

  return value;
}

var _chunkD5ZGX3CTjs = require('./chunk-D5ZGX3CT.js');

var _jotai = require('jotai');

var _react = require('react');

var _utils = require('jotai/utils');

var T = function T() {
  var m = _utils.useResetAtom.call(void 0, _chunkD5ZGX3CTjs.a),
      n = _utils.useResetAtom.call(void 0, _chunkD5ZGX3CTjs.b),
      s = _utils.useResetAtom.call(void 0, _chunkD5ZGX3CTjs.c),
      _jotai$useAtom$call = _jotai.useAtom.call(void 0, _chunkD5ZGX3CTjs.f),
      _jotai$useAtom$call2 = _slicedToArray(_jotai$useAtom$call, 2),
      r = _jotai$useAtom$call2[0],
      a = _jotai$useAtom$call2[1];

  return _react.useCallback.call(void 0, function () {
    if (typeof document > "u") return;
    var e = document.querySelectorAll(".hammer-modal-backdrop, .hammer-modal-container");

    if (e.length === 2) {
      e[0].addEventListener("animationend", function () {
        var _iterator = _createForOfIteratorHelper(e),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var t = _step.value;
            var o = t;
            o.style.display = "none";
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        a(null), _optionalChain([r, 'optionalAccess', function (_) {
          return _[1];
        }, 'call', function (_2) {
          return _2(!1);
        }]), m(), n(), s();
      });

      var _iterator2 = _createForOfIteratorHelper(e),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var t = _step2.value;

          var o = t,
              c = _nullishCoalesce(_optionalChain([o, 'access', function (_3) {
            return _3.className;
          }, 'access', function (_4) {
            return _4.match;
          }, 'call', function (_5) {
            return _5(/hammer-modal-(backdrop|container)/g);
          }, 'optionalAccess', function (_6) {
            return _6[0];
          }]), function () {
            return "";
          });

          o.classList.toggle(c + "-reverse"), o.style.opacity = "0.7", c === "hammer-modal-container" && (o.style.transform = "scale(0.7)");
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, [a, r, m, n, s]);
};

exports.a = T;